export default __webpack_public_path__ + "static/media/asoebi_stock.17a8b6a7.png";